<template>
  <div id="app">
    <iframe
      src="./mms3D/index1.html"
      frameborder="0"
      id="frame"
      scrolling="auto"
    ></iframe>
    <div class="top-left"></div>
    <div class="top-right"></div>
    <div id="app-top">
      <div class="top-title">
        <span>{{ titleName }}</span>
      </div>
      <div class="ab-time">
        <span>{{ time }}</span>
      </div>
      <div class="button">
        <div
          :class="currentIndex == 1 ? 'btn1 btn-active' : 'btn1'"
          @click="animationPlay(1)"
        >
          视角跟随
        </div>
        <!-- <div
          :class="currentIndex == 2 ? 'btn2 btn-active' : 'btn2'"
          @click="startCruise(2)"
        >
          开启巡游
        </div>
        <div
          :class="currentIndex == 3 ? 'btn3 btn-active' : 'btn3'"
          @click="stopCruise(3)"
        >
          关闭巡游
        </div> -->
      </div>
    </div>
    <div class="app-left">
      <leftItem></leftItem>
    </div>

    <div class="app-right">
      <rightItem></rightItem>
    </div>

    <div id="app-bottom"></div>

    <!-- 
    <publicItem>
      <publicTitle></publicTitle>
    </publicItem> -->
  </div>
</template>

<script>
import leftItem from './components/left.vue'
import rightItem from './components/right.vue'
import publicItem from './components/publicItem/publicItem.vue'
import publicTitle from './components/publicItem/publicTitle.vue'
import echarts from 'echarts'
export default {
  components: {
    leftItem,
    publicItem,
    publicTitle,
    rightItem
  },
  data() {
    return {
      titleName: '遨博智慧工厂数字孪生',
      currentIndex: 0,
      time: ''
    }
  },
  mounted() {
    // this.select2();
    var _this = this
    setInterval((function time() {
      _this.showTime()
      return time
    })(), 60000)
  },
  methods: {
    animationPlay(index) {

      document.getElementById('frame').contentWindow.window.MMAPI.animation(1)
      this.currentIndex = index
      console.log(index, this.currentIndex)
    },
    stopCruise(index) {
      this.currentIndex = index
      console.log(index, this.currentIndex)
      document.getElementById('frame').contentWindow.window.MMAPI.stopCruise()
    },
    startCruise(index) {
      this.currentIndex = index
      console.log(index, this.currentIndex)
      document.getElementById('frame').contentWindow.window.MMAPI.startCruise()
    },
    showTime() {
      let time = new Date(new Date())
      let year = time.getFullYear()
      let moth = time.getMonth()
      let day = time.getDate()
      let hour = time.getHours()
      let min = time.getMinutes()
      let times = `${hour}:${min}`
      let _week = ['日', '一', '二', '三', '四', '五', '六']
      let week = time.getDay()
      this.time = `${year}-${moth}-${day} ${times} 星期${_week[week]}`
    }
  }
}
</script>

<style scoped>
#app {
  /* background: url("./assets/image/ab_bg.png") no-repeat;
  background-size: 100% 100%; */
  overflow: hidden;
}
#app-top {
  width: 100%;
  height: 11%;
  position: absolute;
  top: 0px;
  left: 0px;
  /* background-color: rgba(36, 34, 34, 0.541) !important; */
  background: url('./assets/image/ba_top_title_bg.png') no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.top-title {
  position: absolute;
  top: -4.5%;
  width: 33%;
  height: 100%;
  background: url('./assets/image/ab_title_box_bg.png') no-repeat;
  background-size: 100% 152.5%;
  left: 33.6%;
  color: white;
  text-shadow: aquamarine;
  display: flex;
  justify-content: center;
  font-weight: 600;
}
.top-left {
  position: absolute;
  width: 6%;
  height: 91%;
  background: url('./assets/image/ab_left_bj.png') no-repeat;
  background-size: 100% 100%;
  left: 0%;
  top: 4%;
  display: flex;
}
.top-right {
  position: absolute;
  width: 15px;
  height: 91%;
  background: url('./assets/image/ab_right_bj.png') no-repeat;
  background-size: 100% 100%;
  right: 0%;
  top: 4%;
  display: flex;
}
#table {
  width: 30%;
  height: 5%;
  position: absolute;
  border: 1px solid rgb(26, 139, 124);
  left: 0px;
}

.top-title span {
  font-size: 1.6vw;
  margin-top: 6%;
  text-shadow: #096663;
}

#app-bottom {
  width: 100%;
  height: 7%;
  bottom: 0px;
  left: 0px;
  position: absolute;
  background: url('./assets/image/xibiaoxian.png') no-repeat;
  background-size: 100% 100%;
}
.button {
  width: 24%;
  height: 38%;
  position: absolute;
  left: 12%;
  top: 55%;
  display: flex;
  justify-content: space-between;
  /* margin-right: 20px; */
}
.button div {
  width: 25%;
  border: 1px solid #4eaed0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* text-align: center; */
  /* line-height: 45px; */
  cursor: pointer;
  background-color: rgba(127, 187, 214, 0.671);
  border-radius: 80px;
}
/* 按钮 */
#mybtn {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  background: #096d6d;
  color: rgb(153, 225, 228);
  text-align: center;
  margin-top: 10px;
  margin-left: 22%;
}
#frame {
  position: absolute;
  top: 0px;
  left: 0px;
}

#frame {
  width: 100%;
  height: 100%;
  z-index: 0;
}

.btn-active {
  color: yellow;
}

.ab-time {
  color: #00c1bb;
  display: inline-block;
  float: right;
  margin-top: 3%;
  margin-right: 3%;
}
</style>

